import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";

import { transformViewDate } from "utils/date-utils";
import useStyles from "./styles";

interface IProps {
  title: string;
  deadline: string;
  trainerName: string;
}

const StallApplicationHeader = (props: IProps) => {
  const { title, trainerName, deadline } = props;
  const classes = useStyles();
  const transformedDeadline = transformViewDate(deadline, null, "MMMM d, yyyy");

  return (
    <div className={classes.root}>
      <div className={classes.leftSide}>
        <div className={classes.bold}>{title}</div>
        <div
          className={classes.deadline}
        >{`Deadline: ${transformedDeadline}`}</div>
      </div>
      <div className={classes.rightSide}>
        <div className={clsx(classes.trainerName, classes.bold)}>
          {trainerName}
        </div>
        <Button variant={"outlined"} className={classes.contactButton}>
          Contact
        </Button>
      </div>
    </div>
  );
};

export default React.memo(StallApplicationHeader);
